var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtualBackgroundFilled = function SvgVirtualBackgroundFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20c0 10.493-8.507 19-19 19S1 30.493 1 20 9.507 1 20 1s19 8.507 19 19Z",
    fill: "#202020",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2 11H12.8a1.8 1.8 0 0 0-1.8 1.8v14.4a1.8 1.8 0 0 0 1.8 1.8h14.4a1.8 1.8 0 0 0 1.8-1.8V12.8a1.8 1.8 0 0 0-1.8-1.8Zm-9.814 11.484 1.932 2.8 2.866-6.615a.9.9 0 0 1 1.63-.05l3.386 6.673V12.8H12.8v14.184l3.105-4.5a.901.901 0 0 1 1.481 0ZM17.3 20a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4Zm.9-2.7a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0Zm4.874 3.842L26.15 27.2h-5.7l2.624-6.058Zm-6.428 3.438 1.806 2.62h-3.614l1.808-2.62Z",
    fill: "#fff"
  })));
};
export default SvgVirtualBackgroundFilled;